/**
 * MacroTile — single large stacked tile (label above, big value below).
 *
 * Used for the summary grid in FoodAnalysisReview. Long labels truncate
 * with the full text on the `title` attribute so it remains reachable on
 * hover and via screen readers.
 */
import clsx from 'clsx'

const COLOR_CLASSES = {
  indigo: 'bg-indigo-50 text-indigo-900',
  blue: 'bg-blue-50 text-blue-900',
  green: 'bg-green-50 text-green-900',
  amber: 'bg-amber-50 text-amber-900',
}

export default function MacroTile({
  label,
  value,
  unit,
  color = 'indigo',
  className = '',
}) {
  const colorClass = COLOR_CLASSES[color] ?? COLOR_CLASSES.indigo

  return (
    <div className={clsx('rounded-lg p-3 flex flex-col', colorClass, className)}>
      <span
        className="text-xs uppercase tracking-wide truncate opacity-75"
        title={label}
      >
        {label}
      </span>
      <div className="mt-1 flex items-baseline gap-1">
        <span className="text-2xl font-semibold tabular-nums leading-none">
          {value}
        </span>
        {unit && <span className="text-sm opacity-75">{unit}</span>}
      </div>
    </div>
  )
}
